import { useState } from "react";
import Modal from "@/components/Modal";
import ImportModal from "./ImportModal";

function ImportButton() {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <>
            <button type="button" onClick={() => setIsOpen(true)}>
                Import
            </button>
            <Modal isOpen={isOpen} onRequestClose={() => setIsOpen(false)}>
                <ImportModal close={() => setIsOpen(false)} />
            </Modal>
        </>
    );
}

export default ImportButton;
